import { Box, Skeleton } from '@mui/material'
import { hexWithOpacity } from 'common/utils'
import { colors } from 'styles/colors'
import useGlobalStyles from 'styles/globalStyles'

export default function ReimbursementSkeleton() {
  const globalStyles = useGlobalStyles()

  return (
    <Box
      className={globalStyles.positionItemContainer}
      display="flex"
      height="100%"
      justifyContent="space-between"
      alignItems="flex-start"
      sx={{ border: `1px solid ${hexWithOpacity(colors.secondary, 0.5)} !important` }}
    >
      {/* Left content */}
      <Box
        height="100%"
        display="flex"
        flexDirection="column"
      >
        <Box my={0.4}>
          <Skeleton
            variant="text"
            width={140}
            height={22}
            sx={{ bgcolor: colors.skeleton }}
          />
        </Box>

        <Box my={0.4}>
          <Skeleton
            variant="text"
            width={180}
            height={16}
            sx={{ bgcolor: colors.skeleton }}
          />
        </Box>

        <Box my={0.4}>
          <Skeleton
            variant="text"
            width={180}
            height={18}
            sx={{ bgcolor: colors.skeleton }}
          />
        </Box>

        <Box my={0.4}>
          <Skeleton
            variant="text"
            width={180}
            height={18}
            sx={{ bgcolor: colors.skeleton }}
          />
        </Box>

        <Box my={0.4}>
          <Skeleton
            variant="text"
            width={180}
            height={18}
            sx={{ bgcolor: colors.skeleton }}
          />
        </Box>
      </Box>

      {/* Options icon */}
      <Skeleton
        variant="circular"
        width={24}
        height={24}
        sx={{ bgcolor: colors.skeleton }}
      />
    </Box>
  )
}
